"use strict";
// Copyright (c) 2026 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.previewAddress = void 0;
const previewAddress = (address) => {
    const addressWithoutPrefix = address.includes(':')
        ? address.split(':')[1]
        : address;
    return `${addressWithoutPrefix.slice(0, 3)}...${addressWithoutPrefix.slice(-3)}`;
};
exports.previewAddress = previewAddress;
//# sourceMappingURL=address.js.map